module.exports = __webpack_public_path__ + "img/price-table.91203f94.png";